import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './public.routes';
import Case from './case';

export default angular
  .module('verifyApp.public', [
    uiRouter, Case,
  ])
  .config(routing)
  .name;



// WEBPACK FOOTER //
// ./client/app/public/index.js